<template>
  <div>
    <div
      class="overlay-div-contact"
      :style="{
        'background-image': `url(${imgHeader})`,
        '--panelImgColor': rgbaTransparent
      }"
    >
      <div class="text-light overlay-text d-flex flex-column justify-content-center pl-xl-5 mx-xl-5">
        <h1 class="text-left">{{ dataHeader }}</h1>
        <p>
          <b>
            <span class="pointer" @click="$router.push('/')">{{ $t('nav.home') }}</span> >> {{ dataHeader }}
          </b>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { resolveStoredPublicDomain } from "@/utils/publicDomainStorage";

export default {
  props: ["imgHeader", "dataHeader"],
  data() {
    return {
      ConfiguracionGeneralHeader: {},
      localColors: {
        primaryTransparent: "#000000",
        opacity: 0.5,
      },
    };
  },
  async mounted() {
    await this.getConfiguracion();
  },
  methods: {
    resolvePublicDomain() {
      return resolveStoredPublicDomain(this.$domain);
    },
    async getConfiguracion() {
      try {
        const resolvedDomain = this.resolvePublicDomain();
        let ConfiguracionGeneral = await this.$store.dispatch("get", {
          path: `Configuracion_General/public/getAll?domain=${encodeURIComponent(resolvedDomain)}`,
        });
        console.log("----ConfiguracionGeneral---", ConfiguracionGeneral);
        this.ConfiguracionGeneralHeader = ConfiguracionGeneral[0] || {};
        this.loadColors();
      } catch (error) {
        console.error("Error en getConfiguracion:", error);
        this.ConfiguracionGeneralHeader = {};
      }
    },
    hexToRgb(hex) {
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result
        ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16),
          }
        : { r: 0, g: 0, b: 0 };
    },
    loadColors() {
      try {
        const colorsStr = this.ConfiguracionGeneralHeader?.Panel_Img_Color;
        if (colorsStr) {
          const colors = JSON.parse(colorsStr);

          let validColor = colors.primaryTransparent || "#000000";
          if (!/^#[0-9A-F]{6}$/i.test(validColor)) {
            console.warn("Color hexadecimal inválido. Usando fallback.");
            validColor = "#000000";
          }

          let validOpacity = 0.5;
          if (colors.opacity != null && !isNaN(parseFloat(colors.opacity))) {
            validOpacity = Math.max(0, Math.min(1, parseFloat(colors.opacity)));
          }

          this.localColors = {
            primaryTransparent: validColor,
            opacity: validOpacity,
          };
        }
      } catch (error) {
        console.error("Error al cargar colores en Home:", error);
      }
    },
  },
  computed: {
    rgbaTransparent() {
      const rgb = this.hexToRgb(this.localColors.primaryTransparent);
      return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${this.localColors.opacity})`;
    },
  },
};
</script>

<style scoped>
.overlay-div-contact {
  height: 65vh !important;
  position: relative;
  background-size: cover;
  background-position: center;
  align-items: center;
  overflow: hidden;
}

.overlay-div-contact::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--panelImgColor); /* ✅ Ahora sí funciona */
  z-index: 1;
}

.overlay-text {
  position: relative;
  z-index: 2;
  margin: 0;
  /* color: white; */
  padding-left: 2rem;
  height: 100%;
}

.overlay-text h1,
.overlay-text p {
  margin: 0;
  text-align: left;
}

.overlay-text.d-flex {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>
